import { ShiftManagementSelectableEmployeesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

type PermissionAction = 'read' | 'create'

// Employees USING SHIFT MANAGEMENT + that I have permissions to read/create shifts
const useSelectableEmployees = (
  startAt: string,
  endAt: string,
  action: PermissionAction = 'create'
) => {
  const isRead = action === 'read'
  // Cache-first to avoid fetching the same data multiple times
  // because SelectableEmployees is stable and doesn't change frequently.
  //
  // This returns employees using shiftmanagement, but I might not have permissions for them
  const { data: selectableEmployeesData, loading: selectableEmployeesLoading } = useQuery(
    ShiftManagementSelectableEmployeesDocument,
    {
      fetchPolicy: 'cache-first',
      variables: {
        startAt,
        endAt,
      },
    }
  )

  const { data: terminatedEmployeesData, loading: terminatedEmployeesLoading } = useQuery(
    ShiftManagementSelectableEmployeesDocument,
    {
      fetchPolicy: 'cache-first',
      variables: {
        startAt,
        endAt,
        terminated: true,
      },
      skip: !isRead,
    }
  )

  const employeesPermissions = selectableEmployeesData?.shiftManagement.employeesPermissions
  const selectableEmployeeIds =
    employeesPermissions?.reduce<number[]>((acc, employee) => {
      if (isRead || employee.permissions?.create) {
        acc.push(employee.id)
      }
      return acc
    }, []) ?? []

  const terminatedEmployeeIds =
    terminatedEmployeesData?.shiftManagement.employeesPermissions?.reduce<number[]>(
      (acc, employee) => {
        if (isRead) acc.push(employee.id)
        return acc
      },
      []
    ) ?? []

  return {
    loading: selectableEmployeesLoading || terminatedEmployeesLoading,
    selectableEmployeeIds: [...selectableEmployeeIds, ...terminatedEmployeeIds],
  }
}

export { useSelectableEmployees }
